import { render, staticRenderFns } from "./AddCourseOverview.vue?vue&type=template&id=502b88a2&"
import script from "./AddCourseOverview.vue?vue&type=script&lang=ts&"
export * from "./AddCourseOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports